import type { ErrorInfo, ReactNode } from 'react'
import { Component } from 'react'

import ExceptionStateComponent from '@space-shell/common/components/exceptionSate'

import { APP_NAME, APP_VERSION } from './constants'

type Props = {
  children: ReactNode
}

type State = {
  hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false
  }

  constructor(props: Props) {
    super(props)
  }

  static getDerivedStateFromError() {
    return {
      hasError: true
    }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (window.newrelic) {
      try {
        window.newrelic.setApplicationVersion(`${APP_NAME}_v${APP_VERSION}`)
        window.newrelic.noticeError(error, {
          microfrontend_name: String(APP_NAME),
          microfrontend_version: String(APP_VERSION),
          componentStack: errorInfo?.componentStack || 'No component stack available',
          errorStack: error?.stack || 'No stack trace'
        })
      } catch (error) {
        console.error('Error sending error to New Relic', error)
      }
    }
    console.error(error, errorInfo)
  }

  reload() {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return <ExceptionStateComponent exception='internalError' buttonAction={this.reload} />
    }

    return this.props.children
  }
}

export default ErrorBoundary
